import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { ConnectorTypeStoreModelEnum, EvseStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

import { appCharger16Icon } from '@icons/charger-16';
import { appCharger40Icon } from '@icons/charger-40';
import { appCharging16Icon } from '@icons/charging-16';
import { appCharging40Icon } from '@icons/charging-40';
import { appConnectorChademo16Icon } from '@icons/connector-chademo-16';
import { appConnectorChademo40Icon } from '@icons/connector-chademo-40';
import { appConnectorMcs16Icon } from '@icons/connector-mcs-16';
import { appConnectorMcs40Icon } from '@icons/connector-mcs-40';
import { appConnectorNacs16Icon } from '@icons/connector-nacs-16';
import { appConnectorNacs40Icon } from '@icons/connector-nacs-40';
import { appConnectorType216Icon } from '@icons/connector-type2-16';
import { appConnectorType240Icon } from '@icons/connector-type2-40';
import { appFaulted16Icon } from '@icons/faulted-16';
import { appFaulted40Icon } from '@icons/faulted-40';
import { appQueued16Icon } from '@icons/queued-16';
import { appQueued40Icon } from '@icons/queued-40';
import { appUnknown16Icon } from '@icons/unknown-16';
import { appUnknown40Icon } from '@icons/unknown-40';
import { appWrench40Icon } from '@icons/wrench-40';

import { EVSE_STATUS_PROPERTIES_MAP } from './evse-status-icon.view-model';

@Component({
  selector: 'app-evse-status-icon',
  imports: [NgClass, SvgIconComponent],
  templateUrl: './evse-status-icon.component.html',
  styleUrl: './evse-status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvseStatusIconComponent {
  public status = input.required<EvseStatusStoreModelEnum>();
  public connectorType = input<ConnectorTypeStoreModelEnum>();
  public iconVariant = input<'16' | '40'>('40');
  public iconSize = input<string>('40');
  public containerClasses = input<string>();

  public readonly STATUS_PROPERTIES_MAP = EVSE_STATUS_PROPERTIES_MAP;
  public readonly DEFAULT_CONNECTOR_TYPE = ConnectorTypeStoreModelEnum.Ccs2;

  constructor() {
    injectRegisterIcons([
      appCharging16Icon,
      appCharging40Icon,
      appQueued16Icon,
      appQueued40Icon,
      appCharger16Icon,
      appConnectorType216Icon,
      appConnectorChademo16Icon,
      appConnectorNacs16Icon,
      appConnectorMcs16Icon,
      appCharger40Icon,
      appConnectorType240Icon,
      appConnectorChademo40Icon,
      appConnectorNacs40Icon,
      appConnectorMcs40Icon,
      appFaulted16Icon,
      appFaulted40Icon,
      appUnknown16Icon,
      appUnknown40Icon,
      appWrench40Icon,
    ]);
  }
}
